import { render, staticRenderFns } from "./base-form-item.vue?vue&type=template&id=ef36ada4"
import script from "./base-form-item.vue?vue&type=script&lang=js"
export * from "./base-form-item.vue?vue&type=script&lang=js"
import style0 from "./base-form-item.vue?vue&type=style&index=0&id=ef36ada4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports